import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"
//import { isEmptyObj } from "../../helpers"
//import { arrayToObject } from "../../helpers"

// export const FETCH_CMS = "FETCH_CMS"
// export const FETCH_CMS_REQUEST = "FETCH_CMS_REQUEST"
// export const FETCH_CMS_SUCCESS = "FETCH_CMS_SUCCESS"
// export const FETCH_CMS_FAILURE = "FETCH_CMS_FAILURE"

export const FETCH_CMS_CARDS = "FETCH_CMS_CARDS"
export const FETCH_CMS_CARDS_REQUEST = "FETCH_CMS_CARDS_REQUEST"
export const FETCH_CMS_CARDS_SUCCESS = "FETCH_CMS_CARDS_SUCCESS"
export const FETCH_CMS_CARDS_FAILURE = "FETCH_CMS_CARDS_FAILURE"

const initialState = {
	data: {
		cards: [],
	},
	didLoaded: false,
	errorMessage: "",
}

export const loadingCMSCardsSelector = createLoadingSelector([FETCH_CMS_CARDS])
export const fetchCMSCards = () => (dispatch, getState) => {
	return dispatch({
		types: [
			FETCH_CMS_CARDS_REQUEST,
			FETCH_CMS_CARDS_SUCCESS,
			FETCH_CMS_CARDS_FAILURE,
		],
		callAPI: (config) =>
			apiClient.get(`api/content/getListOfContents/CardList`, config),
		//shouldCallAPI: (state) =>
		//!loadingCMSCardsSelector(state) && isEmptyObj(state.landingPage.cards),
		payload: {},
	})
}

// export const loadingCMSSelector = createLoadingSelector([FETCH_CMS])
// export const fetchCMS = (path) => (dispatch) => {
// 	return dispatch({
// 		types: [FETCH_CMS_REQUEST, FETCH_CMS_SUCCESS, FETCH_CMS_FAILURE],
// 		callAPI: (config) =>
// 			apiClient.get(`api/content/getListOfContents/${path}`, config),
// 		payload: {},
// 	})
// }

export default function reducer(state = initialState, action) {
	const { payload, errorMessage } = action
	switch (action.type) {
		case FETCH_CMS_CARDS_REQUEST:
			return {
				...state,
				errorMessage: "",
				successMessage: "",
			}
		case FETCH_CMS_CARDS_SUCCESS:
			return {
				...state,
				data: {
					cards: payload,
				},
				didLoaded: true,
			}
		case FETCH_CMS_CARDS_FAILURE:
			return {
				...state,
				errorMessage,
			}
		// case FETCH_CMS_REQUEST:
		// 	return {
		// 		...state,
		// 		errorMessage: "",
		// 		successMessage: "",
		// 	}
		// case FETCH_CMS_SUCCESS:
		// 	return {
		// 		...state,
		// 		data: payload,
		// 		didLoaded: true,
		// 	}
		// case FETCH_CMS_FAILURE:
		// 	return {
		// 		...state,
		// 		errorMessage,
		// 	}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/LandingPage.js